import React, { FC, useState, useEffect } from "react";
import { TableRowInput, TableRowDropdown } from "../Common";
import { HumiditySettings as Model, ShowHumidity } from "../../store/OJEUStore/models";

export interface HumiditySettingsProps {
    humiditySettings: Model,
    saveHumiditySettings: (newHumiditySettings: Model) => void
}

export const HumiditySettings: FC<HumiditySettingsProps> = (props) => {
    const [humiditySettings, setHumiditySettings] = useState(props.humiditySettings);

    const save = () => props.saveHumiditySettings(humiditySettings);
    useEffect(() => {
        setHumiditySettings(props.humiditySettings);
    }, [props.humiditySettings]);

    return (
        <table className="table table-sm mb-1">
            <tbody>
                <TableRowInput
                    name="Humidity Threshold"
                    currentValue={humiditySettings.humidityThreshold}
                    originalValue={props.humiditySettings.humidityThreshold}
                    inputType="number"
                    minValue={50}
                    maxValue={100}
                    onSave={save}
                    onChange={newValue => setHumiditySettings({ ...humiditySettings, humidityThreshold: Number(newValue) })} />

                <TableRowDropdown
                    name="Show Humidity"
                    currentValue={humiditySettings.showHumidity}
                    originalValue={props.humiditySettings.showHumidity}
                    type={ShowHumidity}
                    onChange={newValue => setHumiditySettings({ ...humiditySettings, showHumidity: newValue })}
                    onSave={save} />
            </tbody>
        </table>
    );
};
